export const MODE_STORAGE_KEY = 'qingduo-aigc-agent-mode';
